/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { Autocomplete } from '@material-ui/lab';
import { useTranslation } from 'react-i18next';
import { TextField } from '@material-ui/core';

const propTypes = {
    options: PropTypes.array.isRequired,
    selectedOption: PropTypes.object.isRequired,
    optionLabel: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired
};

const BaseAutoComplete = ({ options, selectedOption, optionLabel, id, onChange, ...rest }) => {
    const { t } = useTranslation();

    const defaultOption = {
        [optionLabel]: ''
    };

    return (
        <Autocomplete
            {...rest}
            id={id}
            disableClearable
            options={[defaultOption, ...options]}
            getOptionSelected={option => option[optionLabel] === selectedOption[optionLabel]}
            getOptionLabel={option => option[optionLabel] || ''}
            filterOptions={filterOptions => filterOptions.filter(option => option[optionLabel] !== '')}
            value={selectedOption}
            noOptionsText={t('no_options')}
            onChange={onChange(id)}
            renderInput={params => <TextField {...params} label={t(id)} key={id} id={id} multiline={false} />}
        />
    );
};

BaseAutoComplete.propTypes = propTypes;

export default BaseAutoComplete;
